import { render, staticRenderFns } from "./pageCreationComponent.vue?vue&type=template&id=6c7e096e&"
import script from "./pageCreationComponent.vue?vue&type=script&lang=js&"
export * from "./pageCreationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports